import { PaginationParams, DataElement } from './common';

export class REPORTS_SCREEN_TYPE_ENUM {
  static INVOICES: string = "INVOICES";
  static RECEIPTS: string = "RECEIPTS";
  static BALANCE: string = "BALANCE";
}

export class Invoice {
  invId: number;
  invDate: Date;
  invTotSum: number;
  invDateFormatted: string;
  invRemainingSum: number;
  invHaktzaa: string | null;
  docLoading: boolean;
  clinicId: string;
  clinicDescr: string;                

  constructor() {}
}

export class Receipt {
  rcptId: number;
  rcptDate: Date;
  rcptTotSum: number;
  invId: number;
  rcptDateFormatted: string;
  docLoading: boolean;
  clinicId: string;
  clinicDescr: string;   

  constructor() {}
}

export class BalanceRow {
  balRef: number;
  balDate: Date;
  balValueDate: Date;
  balDebtSum: number;
  balCreditSum: number;
  balance: number;
  balDateFormatted: string;
  balValueDateFormatted: string;
  balDocKind: string;
  clinicId: string;
  clinicDescr: string;   

  constructor() {}
}


export class InvoiceReportsSearchParams extends PaginationParams {
    clinic?: DataElement;
    fromDate?: Date;
    toDate?: Date;
    documentId?: number;
  
    constructor() {
      super();
    }
  }